import { render, staticRenderFns } from "./dashboard-entities-no-results.vue?vue&type=template&id=a48d8cc8&"
import script from "./dashboard-entities-no-results.vue?vue&type=script&lang=ts&"
export * from "./dashboard-entities-no-results.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-entities-no-results.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports